import { RafEtiket } from './../../models/RafEtiket';


import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Database } from '../database';
import { resolveDefinition } from '../../../node_modules/@angular/core/src/view/util';

@Injectable()
export class Blletiket extends Database {
  constructor() {
    super("RafEtiket");

  }
 rafetiketkle(ID:number,ItemsRef:number,Name:string){

 return new Promise((resolve, reject) => {
    var eklenecekFiyat: number = 0;
    var siparisDetaySecenekleriJSON = "";
    var aciklama = "";
    

    var etiketdetay = new RafEtiket();
    etiketdetay.StokKartiID=ItemsRef;
    etiketdetay.StokAdi=Name;
    etiketdetay.Id=-1;
 
  
 
        
    this.add(etiketdetay).then(a => {

      resolve(a);
    }).catch(x => {
      reject(x);
    })

  });
}

etiketlistesi_temp()
{
  
}





 
}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-etiket.ts